export default __webpack_public_path__ + "static/media/Japanese.51d20ab4.png";